<template>
  <div class="info-new-line" :class="{ 'error': validate, 'shrink': value || state.shrink }">
    <label class="label-class" :class="{ 'necessary-class': necessary}">{{ label }}</label>
    <Select :value="value" v-bind="$attrs" @change="onChange" @blur="onBlur" @focus="onFocus" :filter-option="onFilterOption" showSearch  >
      <template #suffixIcon>
        <img style="width: 13px" src="@/assets/icon/arrow-solid-down.svg" alt="">
      </template>
      <Option v-for="(item, index) in optionList" :key="index" :value="item[_option.value]" :label="item[_option.label]">
        {{ item[_option.label] }}
      </Option>
      <template #notFoundContent>
        <div style="text-align: center;">{{ $t('global.noData') }}</div>
      </template>
    </Select>
    <a-tooltip v-if="title" :title="title" color="rgba(0,0,0,.7)" overlayClassName="tooltip-tips">
      <div class="tip-img">
        <div class="tooltip-icon">
          <img style="width: 16px" src="@/assets/icon/tip.svg" alt="">
        </div>
      </div>
    </a-tooltip>
    <span v-if="validate" class="error-class">{{ rulesContent }}</span>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive, toRefs, computed } from 'vue'
import { Select, Tooltip } from 'ant-design-vue'

export default defineComponent({
  components: { Select, Option: Select.Option, 'a-tooltip': Tooltip },
  props: ['value', 'label', 'disabled', 'rulesContent', 'necessary', 'validate', 'option', 'optionList', 'title'],
  emits: ['update:value', 'update:validate', 'change'],
  setup (props, ctx) {
    const state = reactive({
      shrink: false
    })
    const { value } = toRefs(props)
    return {
      value,
      state,
      _option: computed(() => {
        if (props.option) {
          return props.option
        }
        return {
          label: 'label',
          value: 'value'
        }
      }),
      onChange (val: any) {
        ctx.emit('update:value', val)
        ctx.emit('change', val)
        if (!val && props.necessary) {
          ctx.emit('update:validate', true)
        } else {
          ctx.emit('update:validate', false)
        }
      },
      onBlur () {
        state.shrink = false
      },
      onFocus () {
        state.shrink = true
      },
      onFilterOption (val: any, option: any) {
        return String(option.label).toLowerCase().indexOf(val.toLowerCase()) >= 0
      }
    }
  }
})
</script>
<style lang="less" scoped>
@import './index.less';
:deep(.ant-select-single .ant-select-selector .ant-select-selection-item,
.ant-select-single .ant-select-selector .ant-select-selection-placeholder) {
  height: 40px !important;
  line-height: 40px !important;
}
:deep(.ant-select-selector) {
  height: 40px !important;
}
:deep(.ant-select-selection-search-input) {
  height: 40px !important;
  line-height: 40px !important;
}

@media only screen and (max-width: 992px) {
  :deep(.ant-select-single .ant-select-selector .ant-select-selection-item,
  .ant-select-single .ant-select-selector .ant-select-selection-placeholder) {
    height: 4rem !important;
    line-height: 4rem !important;
  }
  :deep(.ant-select-selector) {
    height: 4rem !important;
  }
  :deep(.ant-select-selection-search-input) {
    height: 4rem !important;
    line-height: 4rem !important;
  }
}
</style>
